import { Component, inject, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AutoCompleteModule, AutoCompleteSelectEvent } from 'primeng/autocomplete';
import { TitleSection } from '../../components/title-section/title-section';
import { IconSvg } from '../../components/icon-svg/icon-svg';
import { ProviderService } from '../../services/provider.service';
import { IProviderDto } from '../../dto/dashboard';
import { ChipModule } from 'primeng/chip';
import { AccordionModule } from 'primeng/accordion';
import { Router } from '@angular/router';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-dashboard',
  imports: [TitleSection, IconSvg, AutoCompleteModule, FormsModule, ChipModule, AccordionModule],
  templateUrl: './dashboard.html',
  styleUrl: './dashboard.css',
})
export class Dashboard implements OnInit {
  private providerService = inject(ProviderService);
  private router = inject(Router);
  private toastService = inject(ToastService);

  searchValue: string = '';

  isLoading = signal(false);

  selectedProvider: IProviderDto | null = null;

  allProviders: IProviderDto[] = [];

  filteredProviders: IProviderDto[] = [];

  ngOnInit(): void {
    this.providerService.getProviders().subscribe({
      next: (providers) => {
        this.allProviders = providers;
        this.isLoading.set(false);
      },
      error: (error) => {
        this.toastService.error('Erreur lors du chargement des prestataires');
        this.isLoading.set(false);
      },
      complete: () => {
        this.isLoading.set(false);
      }
    });
  }

  onSearchProviders(event: any): void {
    const normalize = (str: string) => str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    const query = normalize(event.query.trim());

    this.filteredProviders = this.allProviders.filter(provider => {
      const matchEmail = normalize(provider.email).includes(query);
      const matchCompany = normalize(provider.companyName ?? '').includes(query);

      return matchEmail || matchCompany;
    });
  }

  onSelectProvider(event: AutoCompleteSelectEvent): void {
    this.router.navigate([`/prestataire/${event.value.id}/detail`]);
  }
}
